import { useCallback } from "react"
import { useGiftRegistryContext } from "@app/providers/giftRegistry"

export const useGiftRegistry = () => {
  const { enrichedGiftRegistries } = useGiftRegistryContext()

  const getRegistryId = useCallback(() => {
    const params = new Proxy(new URLSearchParams(typeof window !== "undefined" && window?.location?.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    return params?.id
  }, [])

  // const registryActive = useCallback((date: any) => {
  //   return new Date(date).getTime() > Date.now()
  // }, [])

  const registryActive = useCallback((date: any) => {
    let inputDate = new Date(date)
    let currentDate = new Date()

    inputDate = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate())
    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())

    return inputDate.getTime() > currentDate.getTime()
  }, [])

  const formatDate = useCallback((date: any) => {
    if (!date) return ""
    const dates = date?.split("-")
    return `${dates[2]}/${dates[1]}/${dates[0]}`
  }, [])

  const getRegistry = useCallback(
    (id: string) => {
      return enrichedGiftRegistries?.length && enrichedGiftRegistries?.find(({ Id }) => Id === id)
    },
    [enrichedGiftRegistries]
  )

  // Custom sorting function for gift registry lists
  const registryListCustomSort = useCallback(
    (a, b) => {
      const aActive = registryActive(a?.expiryDate)
      const bActive = registryActive(b?.expiryDate)

      // First, compare the state
      if (aActive && !bActive) {
        return -1 // 'a' comes before 'b'
      } else if (!aActive && bActive) {
        return 1 // 'b' comes before 'a'
      }

      // If states are the same, compare by date
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)

      if (dateA < dateB) {
        return -1 // 'a' comes before 'b'
      } else if (dateA > dateB) {
        return 1 // 'b' comes before 'a'
      }

      return 0 // items are equal
    },
    [registryActive]
  )

  return {
    formatDate,
    // enrichedGiftRegistries,
    getRegistry,
    getRegistryId,
    // giftRegistries,
    registryActive,
    registryListCustomSort,
  }
}
